import { render, staticRenderFns } from "./CoverageCard.vue?vue&type=template&id=1f4dc2c7"
import script from "./CoverageCard.vue?vue&type=script&lang=js"
export * from "./CoverageCard.vue?vue&type=script&lang=js"
import style0 from "./CoverageCard.vue?vue&type=style&index=0&id=1f4dc2c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports